export default __webpack_public_path__ + "images/custom_f3c582.svg";